
function generateAccessibilityLiveRegionElement(message = "",type = "polite"){
    const idLiveRegionElement = "accessibility-live-region";

    if(document.getElementById(idLiveRegionElement)){
        document.getElementById(idLiveRegionElement).remove();
    }

    const liveRegionElement = document.createElement("div");
    liveRegionElement.setAttribute("id",idLiveRegionElement);
    liveRegionElement.setAttribute("aria-live",type);
    liveRegionElement.setAttribute("role","status");
    liveRegionElement.setAttribute("aria-atomic","true");
    liveRegionElement.setAttribute("style","position: absolute; left: -9999px");
    liveRegionElement.innerText = message;
    document.body.prepend(liveRegionElement);
    console.info("Live Region Message: " + message);
}

export function setAccessibilityLiveRegionMessage(message = "", type = "polite"){
    generateAccessibilityLiveRegionElement(message,type);
}